import React, { useState } from 'react';
import SectionWell from './SectionWell';
import EditSection from './EditSection';
import PatientInfo from '../PatientInfo';

const PatientInformation = ({
	gearOrder,
	patientDetails,
	userInfo,
	editRef,
	triggerInlineSave,
	editingReq,
	editingSection,
	lastSavedSection,
	onEdit,
	cancelEdit,
	saveEdit,
	isEditSaveInProgress,
	inlineSaveError,
	setInsuranceOptions
}) => {
	const [loading, setLoading] = useState(false);
	if (editingSection === 'patient') {
		/**
		 * The Patient Info section is pretty tall so a vertically centered spinner is usually out of view.
		 * When saving, move the spinner to the bottom so it is visible near the Save button.
		 * When waiting on patient lookup, move the spinner near the top so it is visible near the search field.
		 */
		let spinnerLocation = '90%';
		if (loading && !isEditSaveInProgress) {
			spinnerLocation = '10%';
		}
		let loadingComponent = (
			<div className="loading-shield" style={{ position: 'absolute', zIndex: '90' }}>
				<i
					className="fa fa-spinner fa-spin fa-fw loading-icon"
					style={{ width: '1em', position: 'absolute', top: spinnerLocation }}
				></i>
			</div>
		);

		return (
			<div data-step="patient">
				<div className="confirmation-section">
					<div className="">
						<EditSection
							title="Patient Information"
							onCancel={cancelEdit}
							onSave={saveEdit}
							isEditSaveInProgress={isEditSaveInProgress || loading}
							loadingComponent={loadingComponent}
						>
							<PatientInfo
								editRef={(ref) => (editRef.current = ref)}
								triggerInlineSave={triggerInlineSave}
								userInfo={userInfo}
								gearOrder={gearOrder}
								setInsuranceOptions={setInsuranceOptions}
								setLoading={(value) => setLoading(value)}
								doConfirm={() => {/* Not Used*/}}
								setDirty={() => {/* Not Used*/}}
								showError={() => {/* Not Used*/}}
								setGearOrder={() => {/* Not Used*/}}
							/>
							{inlineSaveError && (
								<div className="validation-message text-danger text-right">{inlineSaveError}</div>
							)}
						</EditSection>
					</div>
				</div>
			</div>
		);
	}
	return (
		<div data-step="patient">
			<SectionWell
				sectionId="patient"
				title="Patient Information"
				changesSaved={lastSavedSection === 'patient'}
				editKey={`patient`}
				onEdit={onEdit}
			>
				{patientDetails}
			</SectionWell>
		</div>
	);
};

export default PatientInformation;
